<template>
    <Modal :id="id" :modalTitle="modalTitle" :class="classes">
        <div v-on:keypress.enter.prevent="enterKey">
            <div class="row">
                <div class="col-12 col-lg-3">
                    <div class="form-group">
                        <label class="generalLabel" for="nombreUsuario">Nombre de usuario</label>
                        <input type="text" autocomplete="username" class="form-control generalInput" id="nombreUsuario"
                            v-model.trim.lazy="v$.nombreUsuario.$model">
                        <div v-if="v$.nombreUsuario.$dirty">
                            <small class="form-text text-danger" v-if="v$.nombreUsuario.required.$invalid">Campo
                                requerido</small>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-3">
                    <div class="form-group">
                        <label class="generalLabel" for="nombreVendor">Vendor</label>
                        <input type="text" autocomplete="username" class="form-control generalInput" id="nombreVendor"
                            v-model.trim.lazy="v$.nombreVendor.$model">
                        <div v-if="v$.nombreVendor.$dirty">
                            <small class="form-text text-danger" v-if="v$.nombreVendor.required.$invalid">Campo
                                requerido</small>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-3">
                    <div class="form-group">
                        <label class="generalLabel" for="contrasena">Contraseña</label>
                        <input type="password" autocomplete="new-password" class="form-control generalInput"
                            id="contrasena" v-model.trim.lazy="v$.contrasena.$model">
                        <div v-if="v$.contrasena.$dirty">
                            <small class="form-text text-danger" v-if="v$.contrasena.required.$invalid">Campo
                                requerido</small>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-3">
                    <div class="form-group">
                        <label class="generalLabel" for="email">Correo electrónico</label>
                        <input type="text" autocomplete="chrome-off" class="form-control generalInput" id="email"
                            v-model.trim.lazy="v$.email.$model">
                        <div v-if="v$.email.$dirty">
                            <small class="form-text text-danger"
                                v-if="v$.email.email.$invalid && !v$.email.required.$invalid">El
                                formato no es correcto</small>
                            <small class="form-text text-danger"
                                v-if="!v$.email.email.$invalid && v$.email.required.$invalid">Campo
                                requerido</small>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-3">
                    <div class="form-group">
                        <label class="generalLabel" for="tenant">Tenant</label>
                        <VueNextSelect class="form-control generalInput" id="tenant" :options="tenantsData"
                            v-model.trim.lazy="v$.tenant.$model" close-on-select placeholder="" searchable="true" clear-on-close="true"
                            aria-labelledby="Tenant">
                        </VueNextSelect>
                        <div v-if="v$.tenant.$dirty">
                            <small class="form-text text-danger" v-if="v$.tenant.required.$invalid">Campo
                                requerido</small>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-3">
                    <div class="form-group">
                        <label class="generalLabel" for="store">Store</label>
                        <VueNextSelect class="form-control generalInput" id="store" :options="storesData"
                            v-model.trim.lazy="v$.store.$model" close-on-select placeholder="" searchable="true" clear-on-close="true"
                            aria-labelledby="Store">
                        </VueNextSelect>
                        <div v-if="v$.store.$dirty">
                            <small class="form-text text-danger" v-if="v$.store.required.$invalid">Campo
                                requerido</small>
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-4">
                    <label class="float-left mr-3">Añadir Roles</label>
                </div>
                <div class="row mb-4 mt-3 col-12">
                    <div class="col-12 col-lg-3 checkboxes">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="admin_rol"
                                v-model.trim.lazy="roleCheck.admin">
                            <label class="custom-control-label" for="admin_rol">Admin</label>
                        </div>
                    </div>
                    <div class="col-12 col-lg-3 checkboxes">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="super_admin_rol"
                                v-model.trim.lazy="roleCheck.superAdmin">
                            <label class="custom-control-label" for="super_admin_rol">Super Admin</label>
                        </div>
                    </div>
                    <div class="col-12 col-lg-3 checkboxes">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="backoffice_supervisor_rol"
                                v-model.trim.lazy="roleCheck.backofficeSupervisor">
                            <label class="custom-control-label" for="backoffice_supervisor_rol">Backoffice
                                Supervisor</label>
                        </div>
                    </div>
                  <div class="col-12 col-lg-3 checkboxes">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" id="backoffice_member_rol"
                             v-model.trim.lazy="roleCheck.backofficeMember">
                      <label class="custom-control-label" for="backoffice_member_rol">Backoffice
                        Member</label>
                    </div>
                  </div>
                  <div class="col-12 col-lg-3 checkboxes">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="backoffice_admin_rol"
                                v-model.trim.lazy="roleCheck.backofficeAdmin">
                            <label class="custom-control-label" for="backoffice_admin_rol">Backoffice
                                Admin</label>
                        </div>
                    </div>
                  <div class="col-12 col-lg-3 checkboxes">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="backoffice_superadmin_rol"
                                v-model.trim.lazy="roleCheck.backofficeSuperadmin">
                            <label class="custom-control-label" for="backoffice_superadmin_rol">Backoffice
                                Superadmin</label>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-12">
                    <div class="h-100 d-flex justify-content-end align-items-end align-content-end">
                        <button class="btn generalSecondaryButton" @click="clean()">Limpiar</button>
                        <button class="btn btn-primary generalPrimaryButton" :disabled="v$.$invalid" @click="add()"
                            data-dismiss="modal" aria-label="Close">Añadir</button>
                    </div>
                </div>
            </div>
        </div>
    </Modal>
</template>

<script>
import VueNextSelect from 'vue-next-select'
import Modal from '../../Shared/Modal.vue';
import useVuelidate from '@vuelidate/core';
import axios from 'axios';
import {
    required,
    email,
} from '@vuelidate/validators'
export default {
    name: 'UserAdd',
    setup() {
        return { v$: useVuelidate() }
    },
    created() {
        this.loadTenantData();
        this.loadStoresData();
    },
    props: [
        'id',
        'modalTitle',
        'class',
    ],
    data() {
        return {
            classes: this.class,
            nombreUsuario: '',
            nombreVendor: '',
            tenant: '',
            email: '',
            store: '',
            role: [],
            roleCheck: {
                admin: false,
                superAdmin: false,
                backofficeSupervisor: false,
                backofficeMember: false,
                backofficeAdmin: false,
                backofficeSuperadmin: false
            },
            contrasena: '',
            tenantsData: [],
            storesData: [],
        };
    },
    validations() {
        return {
            nombreUsuario: {
                required
            },
            nombreVendor: {
                required
            },
            contrasena: {
                required
            },
            email: {
                required,
                email,
            },
            tenant: {
                required
            },
            store: {
                required
            },
        }
    },
    components: {
        Modal,
        VueNextSelect
    },
    methods: {
        loadTenantData() {
            axios.get(`/tenants`)
                .then((response) => {
                    let arrayTenant = [];
                    response.data.forEach(element => {
                        arrayTenant.push(element.nameNormalized)
                    });
                    this.tenantsData = arrayTenant;
                });
        },
        loadStoresData() {
            axios.get(`/stores/codes`)
                .then((response) => {
                    let arrayStores = [];
                    response.data.forEach(element => {
                        arrayStores.push(element)
                    });
                    this.storesData = arrayStores;
                });
        },
        clean() {
            this.nombreUsuario = '';
            this.nombreVendor = '';
            this.tenant = '';
            this.email = '';
            this.store = '';
            this.roleCheck = {
                admin: false,
                superAdmin: false,
                backofficeSupervisor: false,
                backofficeMember: false,
                backofficeAdmin: false,
                backofficeSuperadmin: false
            };
            this.contrasena = '';
        },
        add() {
            this.role = []
            if (this.roleCheck.admin) this.role.push('admin');
            if (this.roleCheck.superAdmin) this.role.push('super_admin');
            if (this.roleCheck.backofficeMember) this.role.push('Backoffice_member');
            if (this.roleCheck.backofficeAdmin) this.role.push('Backoffice_admin');
            if (this.roleCheck.backofficeSupervisor) this.role.push('Backoffice_supervisor');
            if (this.roleCheck.backofficeSuperadmin) this.role.push('Backoffice_Superadmin');
            let bodyToSend = {
                username: this.nombreUsuario,
                vendor: this.nombreVendor,
                tenant: this.tenant,
                email: this.email,
                store: this.store,
                number: this.number,
                roles: this.role,
                password: this.contrasena
            }
            let vacio = true;
            for (let i in bodyToSend) {
                if (bodyToSend[i] != '') {
                    vacio = false
                    break
                }
            }
            if (!this.v$.$invalid && !vacio) {
                axios.post('/user/create', bodyToSend)
                    .then((response) => {
                        console.log(response);
                        this.$emit("sendRefreshRegisterList", '');
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else {
                this.v$.$validate
            }
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#addUser {
    .modal-content {
        overflow-y: unset;
    }
}

.checkboxes {
    z-index: 0;
}
</style>
